import { SECOND } from "src/constants";

export const MAX_ANIMATION_DURATION = SECOND * 20;
export const MIN_ANIMATION_DURATION = SECOND * 2;
export const ANIMATION_LABEL = "Gift animation played";
